export default {
  about: "เกี่ยวกับ",
  detail: "รายละเอียดองค์กร",
  benefit: "สวัสดิการ",
  size: "ขนาดองค์กร",
  languageThai: "ภาษาไทย",
  languageEnglish: "ภาษาอังกฤษ",

  contact: {
    title: "Contact Us",
    website: "เว็บไซต์",
    email: "อีเมล",
    contactNumber: "เบอร์โทรศัพท์",
    personalContactNumber: "เบอร์ติดต่อส่วนตัว",
    location: "สถานที่ตั้ง",
    location2: "ที่ตั้งองค์กร",
    contactInfo: "ช่องทางการติดต่อ",
    organizationPhone: "เบอร์โทรศัพท์ภายในองค์กร",
    enterPhoneNum: "ระบุหมายเลขโทรศัพท์",
    phoneRequired: "กรุณาระบุหมายเลขโทรศัพท์",
    phoneLengthValidation: "กรุณาระบุหมายเลขโทรศัพท์ 9 หรือ 10 หลัก",
    numberOnlyValidation: "กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น",
    to: "ต่อ",
    phoneOwnerName: "ชื่อเจ้าของหมายเลข",
    enterPhoneOwnerName: "ระบุชื่อเจ้าของหมายเลข",
    phoneOwnerNameRequired: "กรุณาระบุชื่อเจ้าของหมายเลข",
    thaiOrEnglishOnlyValidation: "กรุณากรอกเฉพาะตัวอักษรภาษาไทยหรือภาษาอังกฤษเท่านั้น",
    addPhoneNumber: "เพิ่มเบอร์โทรศัพท์",
    emailRequired: "โปรดระบุอีเมล",
    enterEmail: "ระบุอีเมล",
    max100Characters: "ขนาดไม่เกิน 100 ตัวอักษร",
    emailFormatValidation:
      "โปรดระบุอีเมลในรูปแบบที่กำหนด เช่น name@example.com",
    enterWebsite: "ระบุเว็บไซต์",
    example: "ตัวอย่าง",
    branch: "สาขา",
    setMainBranch: "ตั้งเป็นสาขาหลัก",
    addBranch: "เพิ่มสาขา",
    viewInfo: "ดูข้อมูล",
    locationGuideMessage: "คุณสามารถเพิ่มตำแหน่งที่ตั้งได้ที่ปุ่ม 'เพิ่มสาขา' ด้านล่างนี้",
    noLocationData: "ไม่พบข้อมูลตำแหน่งที่ตั้ง",

    organizationSize: "ขนาดขององค์กร",
    selectOrganizationSize: "เลือกขนาดขององค์กร",

    enterAbout: "ระบุเกี่ยวกับ",
    aboutRequired: "กรุณาระบุเกี่ยวกับ",

    enterBranch: "ระบุสาขา",
    branchRequired: "กรุณาระบุสาขา",

    addressDetail: "เลขที่ / หมู่ / อาคาร",
    enterAddressDetail: "ระบุเลขที่ / หมู่ / อาคาร",
    locationRequired: "กรุณาระบุสถานที่ตั้ง",

    province: "จังหวัด",
    selectProvince: "เลือกจังหวัด",
    provinceRequired: "กรุณาเลือกจังหวัด",

    noSearchData: "ไม่มีข้อมูลที่คุณค้นหา",

    district: "เขต / อำเภอ",
    selectDistrict: "เลือกเขต/อำเภอ",
    districtRequired: "กรุณาเลือกเขต/อำเภอ",

    subDistrict: "แขวง / ตำบล",
    selectSubDistrict: "เลือกแขวง/ตำบล",
    subDistrictRequired: "กรุณาเลือกแขวง/ตำบล",

    postalCode: "รหัสไปรษณีย์",
    enterPostalCode: "ระบุรหัสไปรษณีย์",
  },

  btn: {
    edit: "แก้ไขข้อมูลโปรไฟล์ธุรกิจ",
  },

  img: {
    selectImage: "เลือกรูป",
    banner: "แบนเนอร์",
    logo: "โลโก้",
    changeImage: "เปลี่ยนรูปภาพ",
    recommendedBannerSize: "ขนาดแบนเนอร์ที่แนะนำ",
    maxUploadSize: "อัปโหลดขนาดไฟล์ไม่เกิน",
    fileFormat: "ในรูปแบบ",
    uploadLogoRequired: "กรุณาอัปโหลดรูปโลโก้",
  },

  business: {
    businessInfo: "ข้อมูลธุรกิจ",
    generalInfo: "ข้อมูลทั่วไป",
    companyName: "ชื่อบริษัท",
    enterCompanyName: "ระบุชื่อบริษัท",
    organizationType: "ลักษณะขององค์กร",
    selectOrganizationType: "เลือกลักษณะขององค์กร",
    businessCategory: "หมวดหมู่ธุรกิจ",
    selectBusinessCategory: "กรุณาเลือกหมวดหมู่ธุรกิจ",
    aboutRequired: "กรุณาระบุเกี่ยวกับ",
    max2000Characters: "ข้อความเกิน 2000 ตัวอักษร",
  },
};
